/**
 * Calendar MV2 query API — isolated from MV1 pages/CalendarPage.jsx.
 */
import { getCalendarOrders, getCalendarSpecialEvents } from "@/lib/api";

export const CALENDAR_QUERY_KEY = "calendar-month";

export async function fetchCalendarMonthFromApi(year, month, signal) {
  let ordersByDate = {};
  let specialEvents = [];
  let ordersFailed = false;
  let eventsFailed = false;

  try {
    const ordersRes = await getCalendarOrders(year, month + 1);
    if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
    ordersByDate = ordersRes.data.orders_by_date || {};
  } catch {
    ordersFailed = true;
  }

  try {
    const eventsRes = await getCalendarSpecialEvents(year, month + 1);
    if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
    specialEvents = eventsRes.data.events || [];
  } catch {
    eventsFailed = true;
  }

  return { ordersByDate, specialEvents, ordersFailed, eventsFailed };
}
